import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
//import { Observable } from 'rxjs';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import { OktaAuthService } from '@okta/okta-angular';
import { constants } from 'buffer';



@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  authToken: any;
  constructor(private oktaAuth: OktaAuthService) {
   
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.isAuthenticated()
      .mergeMap((isAuthenticated) => {
        if (!isAuthenticated) {
          return next.handle(request);
        }

        return this.getAccessToken()
          .mergeMap((accessToken) => {
            request = request.clone({
              setHeaders: {
                Authorization: `Bearer ${accessToken}`   
              }
            });
            return next.handle(request);
          })
      });
  }

  private isAuthenticated() : Observable<boolean> {
    return Observable.fromPromise(this.oktaAuth.isAuthenticated());   
  }

  private getAccessToken() : Observable<string> {
    //authToken :this.oktaAuth.getAccessToken();
    //return Observable.fromPromise(this.authToken);
    return Observable.fromPromise(this.oktaAuth.getAccessToken());
  } 

}